// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"81":"597da714","207":"3a011db3","439":"e62590a5","688":"f17cbf05","962":"3a011db3"}[chunkId] + ".chunk.css";
};